import { JWTRole } from "@hackthenorth/north";

const BADGE_RECIPIENT_ROLES = [
  JWTRole.ORGANIZER,
  JWTRole.JUDGE,
  JWTRole.SPONSOR,
  JWTRole.HACKER,
];

export const shouldShowBadgeSupplyWarning = (
  roles: JWTRole[],
  isOrganizer: boolean
): boolean =>
  !isOrganizer && !roles.some((role) => BADGE_RECIPIENT_ROLES.includes(role));
